import { getHeadersWithTokens } from 'api/ApiHelpers';
import CoreInstance from 'api/CoreInstance';
import { IBabiesByGroupsParams } from 'hooks/resources/useBabiesByGroups';

interface IstudentEndpoints {
  postBaby: (arg: any) => any;
  getBaby: (arg: any) => any;
  putBaby: (arg: any, arg2: any) => any;
  getBabies: (arg: any) => any;
  deleteBaby: (arg: any) => any;
  getBabyInitialAssessment: (arg: any) => any;
  putBabyMilestoneAnswer: (arg: any, arg2: any) => any;
  putResetBabyProgress: (arg: any) => any;
  postAssignGroupToBaby: (arg: any, arg2: any) => any;
  deleteUnassignGroupToBaby: (arg: any, arg2: any) => any;
  putSynchronizeKineduBabyWithClassroom: (arg: any, arg2: any) => any;
  postImportProgressFromKinedu: (arg: any) => any;
  postKineduBabies: (arg: any) => any;
  moveBabiesAsTeacher: (arg: any) => any;
  moveBabies: (arg: any) => any;
  getBabiesByGroups: (params: IBabiesByGroupsParams) => Promise<any>;
}

const studentEndpoints: IstudentEndpoints = {
  postBaby: body => CoreInstance.post('/centers/babies', body, getHeadersWithTokens(true)),
  getBaby: babyId => CoreInstance.get(`/centers/babies/${babyId}`, getHeadersWithTokens(true)),
  putBaby: (babyId, body) => CoreInstance.put(`/centers/babies/${babyId}`, body, getHeadersWithTokens(true)),
  getBabies: () => CoreInstance.get('/centers/babies', getHeadersWithTokens(true)),
  deleteBaby: babyId => CoreInstance.delete(`/centers/babies/${babyId}`, getHeadersWithTokens(true)),
  getBabyInitialAssessment: babyId => CoreInstance.get(`/centers/babies/${babyId}/initial_assessment`, getHeadersWithTokens(true)),
  putBabyMilestoneAnswer: (babyId, data) => CoreInstance.put(`/centers/babies/${babyId}/update_progress`, data, getHeadersWithTokens(true)),
  putResetBabyProgress: babyId => CoreInstance.put(`/centers/babies/${babyId}/reset_progress`, getHeadersWithTokens(true)),
  postAssignGroupToBaby: (babyId, body) => CoreInstance.post(`/centers/babies/${babyId}/assign_groups`, body, getHeadersWithTokens(true)),
  deleteUnassignGroupToBaby: (babyId, body) => CoreInstance.delete(`/centers/babies/${babyId}/unassign_groups`, {
    ...getHeadersWithTokens(true),
    params: {
      data: body,
    },
  }),
  putSynchronizeKineduBabyWithClassroom: (babyId, kineduBabyId) => CoreInstance.put(`/centers/babies/${babyId}/sync_kinedu_baby?kinedu_baby_id=${kineduBabyId}`, getHeadersWithTokens(true)),
  postImportProgressFromKinedu: babyId => CoreInstance.post(`/centers/babies/${babyId}/import_kinedu_progress`, getHeadersWithTokens(true)),
  postKineduBabies: emails => CoreInstance.post('/centers/kinedu_resources/babies_associated_to_email', { emails }, getHeadersWithTokens(true)),
  moveBabiesAsTeacher: (data) => CoreInstance.put('/centers/babies/reassign', data, getHeadersWithTokens(true)),
  moveBabies: ({ body, currentCenterId }) => CoreInstance.put(`/organizations/centers/${currentCenterId}/babies/reassign`, body, getHeadersWithTokens()),
  getBabiesByGroups: (params: any) => CoreInstance.get(`centers/babies_groups`, {
    ...getHeadersWithTokens(true), ...{ params }
  }),
};

export default studentEndpoints;
